<template>
  <section id="OurClientsWrap">
    <div class="bg_yellow">
        <div class="ContentAligher SectionTopSpacing SectionBottomSpacing">
            <div class="row">
              <div class="col-xs-10 col-xs-offset-1 ">
                  <div class="row">
                    <div class="col-md-6 pull-right-md">
                        <h1 class="white bold">{{ title }}</h1>
                        <p>{{ description }}</p>
                    </div>
                    <div class="col-md-6">
                      <div id="testimonialsWrap">
                        <img :src="require('@/assets/images/open-q.png')" id="quoteIcon">
                          <div class="row ">
                            <div class="col-md-11 innerBg">
                                <ul id="testimonialsSlider">
                                  <li v-for="testi in testimonials"><p>{{ testi.testimonial }}</p><span>{{ testi.name }}</span><span>{{ testi.position_title }}</span></li>
                                </ul>
                              </div>
                            </div>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
    </div>
    <div class="ContentAligher SectionTopSpacing SectionBottomSpacing">
        <div class="row">
          <div class="col-md-10 col-md-offset-1 col-sm-offset-0">
              <ul class="row logos">
                <li v-for="(cl, key, index) in clients_list" class="col-md-2 col-sm-3 col-xs-4">
                      <img :src="base_path + cl.client_logo"  />
                  </li>
              </ul>
          </div>
        </div>
    </div>
    <div class="BGArrowLeft parallax"  data-speed="20" data-margin="800" data-rotate="0" data-rotatestatus="false" ></div>
  </section>
</template>
<script>

import * as $ from 'jquery'
import Vue from 'vue';


import '@/assets/js/lightslider'

import axios from 'axios'
import { API_BASE_URL } from '../config'
import { BASE_URL } from '../config'


export default{
  name: 'OurClients',
  data: function() {
    return {
      base_path: BASE_URL,
      clients_list: null,
      title: 'Our Clients',
      description:'At USC Elevator Interiors we strive to ensure customer satisfaction and that starts by building relationships with some of the best elevator companies in the business. Our clients know that if they want precision, professionalism, and work that surpasses expectations, we are the ones for the job! ',
      testimonials:null
     //banner:require('./../../static/images/banner/contact.jpg'),
    }
  },
  mounted() {
    axios.get(API_BASE_URL + 'clients/list/')
    .then(response => {this.clients_list = response.data});

    axios.get(API_BASE_URL + 'testimonials/list/')
    .then(response => {this.testimonials = response.data}).finally(function(){
         $('#testimonialsSlider').lightSlider({
            item:1,
            slideMove:1,
            enableTouch:true,
            enableDrag:false,
            loop:false,
            slideMargin:0
          }); 

      });
    


    
  },
  updated(){
     
  }
}
</script>
<style>
@import './../assets/css/lightslider.css';
</style>


// WEBPACK FOOTER //
// src/components/OurClients.vue